import { SvgBase } from "../svg.base";

export const Facebook = () => (
  <SvgBase>
    <path
      fill="currentColor"
      d="M20.328 5.004L17.758 5c-2.888 0-4.754 1.914-4.754 4.878v2.248H10.42a.404.404 0 0 0-.404.405v3.258c0 .223.18.404.404.404h2.584v8.222c0 .223.18.404.404.404h3.372a.404.404 0 0 0 .404-.404v-8.222h3.021c.224 0 .404-.18.404-.404l.002-3.258a.405.405 0 0 0-.405-.405h-3.022V10.22c0-.916.218-1.381 1.412-1.381l1.731-.001a.404.404 0 0 0 .404-.404V5.408a.404.404 0 0 0-.403-.404z"
    />
  </SvgBase>
);